import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { SchedulerProvider } from "./context/schedulerContext";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60000, // 1 minute
      refetchOnWindowFocus: true,
      onError: (err) => {
        console.error("An error occurred:", err);
      },
    },
  },
});

//const rootElement = document.getElementById("root");
const rootElement = document.getElementById("schedulerContainer");
createRoot(rootElement).render(
  // <React.StrictMode>
  <QueryClientProvider client={queryClient}>
    <SchedulerProvider>
      <App />
    </SchedulerProvider>
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>
  // {/* </React.StrictMode> */}
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
